import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../../modules/reports/general/jobMinutesReportActions'
import * as api from '../../../api/reports/general/jobMinutesReport'

function* jobMinutesReportGetJobList(action) {
  try {
    const payload = yield call(api.getJobList, action.filters)
    yield put({ type: constants.JOB_MINUTES_REPORT_GET_JOB_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_MINUTES_REPORT_GET_JOB_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* jobMinutesReportGetUserList(action) {
  try {
    const payload = yield call(api.getUserList, action.filters)
    yield put({ type: constants.JOB_MINUTES_REPORT_GET_USER_LIST.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_MINUTES_REPORT_GET_USER_LIST.FAILED,
      message: e.message || e
    })
  }
}

function* jobMinutesReportGetFullReport(action) {
  try {
    const payload = yield call(api.getFullReport, action.filters)
    yield put({ type: constants.JOB_MINUTES_REPORT_GET_FULL_REPORT.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_MINUTES_REPORT_GET_FULL_REPORT.FAILED,
      message: e.message || e
    })
  }
}

/**
 * Saga
 */
function* watchJobMinutesReportGetJobList() {
  yield takeLatest(constants.JOB_MINUTES_REPORT_GET_JOB_LIST.ACTION, jobMinutesReportGetJobList)
}

function* watchJobMinutesReportGetUserList() {
  yield takeLatest(constants.JOB_MINUTES_REPORT_GET_USER_LIST.ACTION, jobMinutesReportGetUserList)
}

function* watchJobMinutesReportGetFullReport() {
  yield takeLatest(
    constants.JOB_MINUTES_REPORT_GET_FULL_REPORT.ACTION,
    jobMinutesReportGetFullReport
  )
}

/**
 * Export the root saga by forking all available sagas.
 */
export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobMinutesReportGetJobList),
    fork(watchJobMinutesReportGetUserList),
    fork(watchJobMinutesReportGetFullReport)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/reports/general/jobMinutesReportSaga.js